import React, { useState, useEffect } from "react";
import es_ES from "rsuite/locales/es_ES";
import {
  Calendar,
  List,
  HStack,
  Button,
  Text,
  Modal,
  Input,
  toaster,
  Message,
  SelectPicker,
  DatePicker,
  NumberInput,
  CustomProvider,
  Panel,
  AutoComplete,
  Box,
  Badge,
  Tag,
  Header,
  Breadcrumb,
} from "rsuite";
import {
  getCitas,
  getHorarios,
  getPaciente,
  getPacienteXNombre,
  saveCancelCita,
  saveUpdateCita,
  getTelefonoXID,
  getListaPacientes,
  saveConfirmacion,
} from "./Services/ConsultasServices";
import { Consulta } from "./Consulta";
import { FaTrash } from "react-icons/fa";
import { CheckIcon, ClockIcon } from "lucide-react";
import moment from "moment/moment";
import { Image } from "react-bootstrap";

export const Citas = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [messageConfirm, setMessageConfirm] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.msjConfirm,
  );

  const [menuSelected, setMenuSelected] = useState("");
  const [nomPaciente, setNomPaciente] = useState("");
  const [message, setMessage] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [dataPaciente, setDataPaciente] = useState([]);
  const [lista, setLista] = useState([]);
  const [fechaCita, setFechaCita] = useState("");
  const [motivoCancel, setMotivoCancel] = useState("");
  const [dataCancel, setDataCancel] = useState("");
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleCloseConfirm = () => setOpenConfirm(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const [fecha, setFecha] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [telefono, setTelefono] = useState("");
  const [openHor, setOpenHor] = useState(false);
  const [dataEdit, setDataEdit] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [dataConfirm, setDataConfirm] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const handleCloseHorario = () => setOpenHor(false);
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disableHors, setDisableHors] = useState(true);
  const [fechaHorario, setFechaHorario] = useState("");
  const [horario, setHorario] = useState("");
  const [nuevaCita, setNuevaCita] = useState(false);
  const [horNvaCita, setHorNvaCita] = useState("");

  const [disabledBtmMsj, setDisabledBtnMsj] = useState(true);
  const [espacio, setEspacio] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [horaIni, setHoraIni] = useState("");
  const [tipoHorario, setTipoHorario] = useState("");
  const [nuevoPac, setNuevoPac] = useState(false);
  const [showListaPac, setSowListaPac] = useState(true);
  const [listaPacientes, setListaPacientes] = useState([
    { label: "+ NUEVO PACIENTE", value: "-1" },
  ]);

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const fetchHorarios = async (fecha) => {
    await getHorarios(idNegocio, fecha).then((nxt) => {
      setFechaHorario(fecha);
      setDataHorarios(nxt);
    });
  };

  const fetchPaciente = async (valueTel) => {
    setTelefono(valueTel);
    const response = await getPaciente(idNegocio, valueTel);
    if (response.status === 204) {
      setNuevoPac(true);
      setPaciente("");
    } else {
      if (!response.nombre) {
        setNuevoPac(true);
      } else {
        setPaciente(response.nombre);
      }
    }
  };

  const getPacientePorNombre = async (nombre) => {
    const response = await getPacienteXNombre(idNegocio);
    setDataPaciente(response);
  };

  // const getTelefono = async (nombre) => {
  //   const res = await getTelefonoXNombre(idNegocio, nombre);
  //   setTelefono(res);
  // };

  const handleChangeTelefono = async (value) => {
    setTelefono(value);
  };

  const fetchCitas = async (date) => {
    await getCitas(idNegocio, date, "Todas").then((nxt) => {
      setLista(nxt.lstCitas);
      const citas = nxt.lstCitas;
      return citas.length;
    });
  };

  const cancelarCita = async () => {
    var url = `Consultas/cancelarCita`;
    const datos = {
      id: idNegocio,
      espacio: espacio,
      fecha: fechaCita,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      toast("Debes escribir un motivo antes de guardar", "warning");
      return;
    }

    const res = await saveCancelCita(datos);

    if (res.data === -1) {
      toast(
        "No se ha cancelado la cita, porque ya se registro la consulta.",
        "warning",
      );
      return;
    }
    if (res.data === 0) {
      toast("No se ha cancelado la cita, intente nuevamente.", "warning");
      return;
    } else {
      toast("La cita se ha cancelado de forma correcta.", "success");
      setOpen(false);

      fetchCitas(fechaCita);
    }
  };

  const save = async () => {
    var url = `Consultas/updateCita`;

    if (telefono.length < 10) {
      toast("Debes colocar un numero teléfóno.", "error");
      return;
    }

    if (!paciente && nuevoPac) {
      toast("El nombre no puede estar vacio", "error");
      return;
    }

    if (tipoHorario === "horarioLibre" && !horaIni) {
      toast("El horario no puede estar vacio", "error");
      return;
    }

    if (fechaCita) {
      setFechaHorario(fecha);
      setFechaCita(fecha);
      setNuevaFecha(fecha);
    }

    const _idPac = idPaciente;
    const ID = _idPac.split("-")[0];

    const dataCita = {
      id: idNegocio,
      idPaciente: ID,
      espacio: espacio,
      fechaAnterior:
        tipoHorario === "horarioLibre"
          ? nuevaFecha
          : nuevaCita
            ? fecha
            : fechaCita,
      fecha:
        tipoHorario === "horarioLibre"
          ? nuevaFecha
          : nuevaCita
            ? fecha
            : fechaHorario.substring(0, 10),
      hora: tipoHorario === "horarioLibre" ? horaIni : horario,
      nombre: paciente,
      telefono: telefono,
      correo: "",
      domicilio: "",
      edoMun: "",
      descripCita: "",
      nuevaCita: nuevaCita,
      tipoHorario: tipoHorario,
    };

    const res = await saveUpdateCita(dataCita);
    if (res.data === -1) {
      toast("El horario no se encuentra disponible.", "warning");
      return;
    }
    if (res.data === -2) {
      toast(
        "La cita no puede ser re-programada ya se ha realizado.",
        "warning",
      );
      return;
    }

    if (res.data === -3) {
      toast(
        "La cita no puede ser programada el horario esta ocupado.",
        "warning",
      );
      return;
    }

    toast("Se actualizo la cita de forma correcta", "success");
    setDisableBtn(true);
    setDisabledBtnMsj(false);

    fetchCitas(fechaCita);
    setOpenHor(false);
  };

  const saveConfirm = async () => {
    const data = {
      id: idNegocio,
      fechaCita: fechaCita,
      hora: horario,
      espacio: espacio,
    };

    await saveConfirmacion(data)
      .then((res) => {
        if (res.data > 0) {
          toast("Se ha confirmado la cita", "success");
          fetchCitas(fechaCita);
          setOpenConfirm(false);
        }
      })
      .catch((err) => {
        toast(err.message, "error");
      });
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${messageConfirm}`;
    anchor.target = "_blank";
    anchor.click();
    setOpenHor(false);
  };

  const handleSelect = (date) => {
    const _date = moment(date).format("DD/MMM/YYYY");
    const utcDate = moment(date).format("YYYY-MM-DD");
    setFecha(_date);
    setFechaCita(utcDate);
    setLista([]);
    fetchCitas(utcDate);
  };

  const maskTime = (value) => {
    setHoraIni(
      value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1:$2")
        .replace(/(\d{2})(\d)/, "$1:$2"),
    );
  };

  const handleConfirmModal = (props) => {
    setIdPaciente(props.idPac);
    setEspacio(props.espacio);
    setTelefono(props.telefono);
    setHorario(props.hora);
    setOpenConfirm(true);
    setMessageConfirm(
      JSON.parse(localStorage.getItem("auth")).confApp.msjConfirm,
    );

    setDataConfirm(
      `${props.nombre} / (${props.espacio}) ${fechaCita} ${props.hora}`,
    );
  };

  const handleEditModal = (props) => {
    setSowListaPac(true);
    setIdPaciente(props.idPac);
    setDisabledBtnMsj(true);
    setMessage("");
    setTipoHorario(props.opcion);
    setFecha(props.fecha);
    setFechaCita(`${props.fecha} ${props.hora}`);
    setDataEdit(
      `${props.nombre} / (${props.espacio}) ${fechaCita} ${props.hora}`,
    );
    setEspacio(props.espacio);
    setTelefono(props.telefono);
    setPaciente(props.nombre);
    setNuevaCita(false);
    setNuevoPac(false);
    setOpenHor(true);
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);

      fetchHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  const handleHorario = (e) => {
    if (e === null) {
      setHorario("");
      setDisableBtn(true);
      setMessage("");
    } else {
      setHorario(e);
      setDisableBtn(false);
      const _hor = e.substring(0, 5);
      const _fec = moment(fechaHorario).format("DD/MM/YYYY");
      setMessage(
        `Buen día, le escribimos del ${negocio.NomConsultorio}. Confirmando su cambio de Fecha y hora de la cita para el: ${_fec} en el horario de las: ${_hor}`,
      );
    }
  };

  const handleNewCita = async (props) => {
    setListaPacientes([{ label: "+ NUEVO PACIENTE", value: "-1" }]);
    setSowListaPac(true);
    var fec = moment(fecha).format("DD/MM/YYYY");
    setIdPaciente("");
    setDataEdit(`${fec}`);
    setHorario(props.hora);
    setHorNvaCita(props.hora);
    setTelefono("");
    setPaciente("");
    setMessage("");
    setHoraIni("");
    setNuevaCita(true);
    setTipoHorario(props.opcion);
    setNuevaFecha(props.fecha);
    setNuevaCita(props.nuevaCita);
    getPacientePorNombre();
    setNuevoPac(false);
    setOpenHor(true);

    await getListaPacientes(idNegocio).then((res) => {
      setListaPacientes((prev) => [...prev, ...res]);
    });
  };

  const handleNuevoNombre = async (e) => {
    if (!e) {
      setDisableBtn(true);
      setPaciente("");
    } else {
      setDisableBtn(false);
      setPaciente(e);
    }
  };

  const hanldeNombrePaciente = async (e) => {
    
    // if (e === null) {
    //   setIdPaciente("0");
    //   setSowListaPac(false);
    //   setNuevaCita(true);
    //   setPaciente("");
    //   setNuevoPac(true);
    //   setTelefono("");
    //   return;
    // }
    
    if(e === '-1'){
      setIdPaciente("0");
      setSowListaPac(false);
      setNuevaCita(true);
      setPaciente("");
      setNuevoPac(true);
      setTelefono("");
      return;
    }

    const _idPac = e;
    const ID = _idPac.split("-")[0];
    
    setIdPaciente(e);
    const selectedItem = listaPacientes.find(item => item.value === e);
    setPaciente(selectedItem.label);
    
    const res = await getTelefonoXID(idNegocio, ID, selectedItem.label);
    if (!res) {
      setTelefono("");
    }
    if (res.telefono === undefined) {
      return;
    }

    setTelefono(res.telefono);
  };

  const getPaciente = (props) => {
    const getCita = {
      idConsulta: props.idConsulta,
      espacio: props.espacio,
      idPac: props.idPac,
      nombre: props.nombre,
      fecha: props.fecha,
      hora: props.hora,
      precio: props.precio,
      telefono: props.telefono,
    };

    if (props.estatus === "Confirmada") {
      setEspacio(props.espacio);
      localStorage.setItem("getCita", JSON.stringify(getCita));
      setMenuSelected("Consulta");
      setNomPaciente(` (${props.hora}) / (${props.espacio}) ${props.nombre}`);
    }
    if (props.estatus === "Realizada") {
      localStorage.setItem("getCita", JSON.stringify(getCita));
      setNomPaciente(` / ${props.nombre}`);
    }
  };

  const handleCheck = (e) => {
    console.log(e.target.checked);
  }

  const handleCancel = (props) => {
    if (props.estatus === "Cancelada") {
      setBtnCancel(true);
    } else {
      setBtnCancel(false);
    }

    setFechaCita(`${fechaCita} ${props.hora}`);
    setDataCancel(
      `${props.nombre} / (${props.espacio}) ${fechaCita} ${props.hora}`,
    );
    setEspacio(props.espacio);
    setOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    setListaPacientes([{ label: "+ NUEVO PACIENTE", value: "0" }]);
    fetchPaciente();
    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "5px",
        borderRadius: "10px",
      }}
    >
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-4">
          <CustomProvider locale={es_ES} block>
            <Calendar compact onSelect={handleSelect} bordered />
          </CustomProvider>
        </div>

        <div className="col-lg-8 col-md-8 col-sm-8">
          <HStack align="flex-end">
            <Text color="blue" weight="bold" size={"md"}>
              &nbsp; &nbsp; Citas de: <b>{fechaCita}</b>
            </Text>
          </HStack>
          <HStack style={{ padding: "5px" }}>
            <Button
              appearance="ghost"
              color="blue"
              size="sm"
              block
              onClick={() =>
                handleNewCita({
                  idPac: 0,
                  nombre: "",
                  fecha: fechaCita,
                  hora: "",
                  telefono: "",
                  nuevaCita: true,
                  opcion: "horarioLibre",
                })
              }
            >
              Nueva cita
            </Button>
          </HStack>
          {lista.length > 0 ? (
            <List
              style={{ flex: 1, fontSize: isMobile ? "12px" : "16px" }}
              bordered
            >
              {lista.map((item, index) => (
                <List.Item key={`${index}-${item.hora}`} index={item.dia}>
                  <div>
                    <Text weight="semibold">Horario: {item.hora}</Text>
                  </div>
                  <div id={`${index}-${index}`}>
                    {item.estatus === "Disponible" ? (
                      <Button
                        color="green"
                        appearance="ghost"
                        onClick={() =>
                          handleNewCita({
                            idPac: 0,
                            nombre: "",
                            fecha: fechaCita,
                            hora: item.hora,
                            telefono: "",
                            nuevaCita: true,
                            opcion: "horarioDisp",
                          })
                        }
                      >
                        {item.nombre + " (" + item.espacio + ")"}
                      </Button>
                    ) : (
                      <Box
                        c={
                          item.estatus === "Confirmada"
                            ? "white"
                            : item.estatus === "Realizada"
                              ? "blue.600"
                              : "none"
                        }
                        bg={
                          item.estatus === "Confirmada"
                            ? "linear-gradient(45deg, #4CAF50, #2196F3)"
                            : item.estatus === "Realizada"
                              ? "blue.50"
                              : "none"
                        }
                        p={10}
                        rounded={"xl"}
                      >
                        {item.nombre + " (" + item.espacio + ")"}
                      </Box>
                    )}

                    {item.estatus !== "Realizada" &&
                    item.estatus !== "Disponible" ? (
                      <>
                        <Button
                          appearance="subtle"
                          title="Cancelar cita"
                          onClick={() =>
                            handleCancel({
                              nombre: item.nombre,
                              fecha: fechaCita,
                              espacio: item.espacio,
                              hora: item.hora,
                              telefono: item.telefono,
                              estatus: item.estatus,
                            })
                          }
                        >
                          <FaTrash style={{ color: "red" }}></FaTrash>
                        </Button>
                        <Button
                          onClick={() =>
                            handleEditModal({
                              idPac: item.idPac,
                              espacio: item.espacio,
                              nombre: item.nombre,
                              fecha: fechaCita,
                              hora: item.hora,
                              telefono: item.telefono,
                              nuevaCita: false,
                              opcion: "horarioLibre",
                            })
                          }
                          appearance="subtle"
                          title="Editar horario"
                        >
                          <ClockIcon
                            size="15px"
                            style={{ color: "blue" }}
                          ></ClockIcon>
                        </Button>
                        <Button
                          onClick={() =>
                            handleConfirmModal({
                              idPac: item.idPac,
                              espacio: item.espacio,
                              nombre: item.nombre,
                              fecha: item.fecha,
                              hora: item.hora,
                              telefono: item.telefono,
                              nuevaCita: false,
                              opcion: "horarioLibre",
                            })
                          }
                          color="green"
                          appearance="subtle"
                          title="Confirmar cita"
                        >
                          <CheckIcon
                            size="20px"
                            style={{ color: "green" }}
                          ></CheckIcon>
                        </Button>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </List.Item>
              ))}
            </List>
          ) : (
            ""
          )}
        </div>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA CANCELACIONES <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={open}
          onClose={handleClose}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title style={{ fontSize: "16px" }}>{dataCancel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row">
                <div className="col">
                  <b>Motivo</b>
                  <Input
                    as="textarea"
                    rows={4}
                    placeholder="Escriba el motivo de la cancelación de la cita."
                    onChange={(e) => setMotivoCancel(e)}
                    disabled={btnCancel}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={cancelarCita}
              disabled={btnCancel}
              appearance="ghost"
            >
              Guardar
            </Button>
            <Button onClick={handleClose} appearance="ghost">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO Y NUEVA CITA O RE-PROG <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size="lg"
          open={openHor}
          onClose={handleCloseHorario}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataEdit}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row mb-1">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <b>Nombre</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  {showListaPac ? (
                    <SelectPicker
                      key={`pickerPacientes`}
                      width={"100%"}
                      data={listaPacientes}
                      value={idPaciente}
                      onChange={(e) => hanldeNombrePaciente(e)}
                      searchable
                      placeholder="Selecciona un paciente..."
                      block
                    />
                  ) : !nuevoPac ? (
                    <Input readOnly value={paciente} />
                  ) : (
                    <Input
                      value={paciente}
                      onChange={(e) => handleNuevoNombre(e)}
                    />
                  )}

                  {/* <AutoComplete
                    data={nuevoPac ? [] : dataPaciente}
                    width={"100%"}
                    onChange={(e) => hanldeNombrePaciente(e)}
                  /> */}
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <b>Teléfono</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  <NumberInput
                    controls={false}
                    value={telefono}
                    onChange={(e) => handleChangeTelefono(e)}
                    maxLength={10}
                    min={0}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Fecha</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={moment(fecha).format("DD/MM/YYYY")}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <CustomProvider locale={es_ES}>
                      <DatePicker
                        block
                        shouldDisableDate={handleDisabledDate}
                        onChange={(e) => handleChangeFec(e)}
                      />
                    </CustomProvider>
                  ) : (
                    <Input
                      readOnly
                      value={nuevaFecha}
                      style={{ textAlign: "center" }}
                    />
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Horario</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={horNvaCita}
                      defaultValue={horNvaCita}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <SelectPicker
                      style={{ width: "auto" }}
                      block
                      searchable={false}
                      data={dataHorarios}
                      disabled={disableHors}
                      onChange={(e) => handleHorario(e)}
                      placeholder="Selecciona un horario"
                    />
                  ) : (
                    <Input
                      placeholder="00:00"
                      maxLength={5}
                      value={horaIni}
                      onChange={(e) => maskTime(e)}
                      style={{ textAlign: "center" }}
                    />
                  )}
                </div>
              </div>
              <div className="row">
                {!nuevaCita ? (
                  <div className="col">
                    <b>Mensaje</b>
                    <Input
                      as="textarea"
                      rows={3}
                      value={message}
                      onChange={(e) => setMessage(e)}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              appearance="ghost"
              onClick={save}
              disabled={nuevaCita ? false : disableBtn}
            >
              Guardar
            </Button>
            <Button
              appearance="ghost"
              onClick={() => sendMessage()}
              size="md"
              disabled={disabledBtmMsj}
            >
              <Image
                src="/Images/whatsapp.png"
                style={{ height: "30px" }}
              ></Image>
              &nbsp; Enviar mensaje
            </Button>
            <Button onClick={handleCloseHorario} appearance="ghost">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA CONFIRMACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={openConfirm}
          onClose={handleCloseConfirm}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title style={{ fontSize: "16px" }}>
              {dataConfirm}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row">
                <div className="col">
                  <b>Mensaje de confirmación</b>
                  <Input
                    as="textarea"
                    rows={16}
                    value={messageConfirm}
                    onChange={(e) => setMessageConfirm(e)}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={saveConfirm} appearance="ghost">
              Guardar
            </Button>
            <Button appearance="ghost" onClick={() => sendMessage()} size="md">
              <Image
                src="/Images/whatsapp.png"
                style={{ height: "30px" }}
              ></Image>
              &nbsp; Enviar mensaje
            </Button>
            <Button onClick={handleCloseConfirm} appearance="ghost">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
